import Button from 'components/ui/button';

interface AvisoDeCicloForaDaTelaProps {
  /** O ciclo do app, que a tela não tem. */
  ciclo: { title: string };
  /** O ciclo mais recente da tela, para o botão. */
  disponivel?: { _id: string; title: string };
  onVer: (cicloId: string) => void;
}

/**
 * Título da página, para onde o foco vai quando o aviso sai (WCAG 2.4.3). Sem `tabindex`, ganha `-1`: recebe o foco
 * pelo código sem entrar na ordem do Tab.
 */
function tituloDaPagina() {
  const titulo = document.querySelector<HTMLElement>('main h1') ?? document.querySelector<HTMLElement>('h1');
  if (titulo && !titulo.hasAttribute('tabindex')) titulo.setAttribute('tabindex', '-1');
  return titulo;
}

/**
 * CIC-12: a tela não tem o ciclo escolhido no app. Em vez de cair em silêncio em outro ciclo, avisa e oferece o
 * mais recente da tela, que passa a ser o ciclo do app (o menu acompanha).
 *
 * - A mensagem é um `status` (WCAG 4.1.3): trocar o ciclo no menu com a tela aberta troca o conteúdo pelo aviso, e o
 *   leitor de tela anuncia. O `status` fica só na mensagem, sem o botão dentro da região viva.
 * - "Ver o ciclo" leva o foco ao título da página antes de o aviso sair; sem isso, o foco caía no `body`.
 */
export default function AvisoDeCicloForaDaTela({ ciclo, disponivel, onVer }: AvisoDeCicloForaDaTelaProps) {
  function ver(cicloId: string) {
    tituloDaPagina()?.focus();
    onVer(cicloId);
  }

  return (
    <div className="flex flex-col items-center gap-3 rounded-2xl bg-surface-0 px-6 py-9 text-center shadow-jj-01">
      <p role="status" className="m-0 font-display text-lg font-bold text-brand-blue-dark">
        O ciclo {ciclo.title} não está disponível nesta tela.
      </p>
      {disponivel && (
        <Button variant="secundario" size="sm" onClick={() => ver(disponivel._id)}>
          Ver o ciclo {disponivel.title}
        </Button>
      )}
    </div>
  );
}
